import * as React from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";

import { componentDefaults } from "./componentDefaults";
import { defaultThemeMode } from "./modes";
import { createPalette } from "./palette";
import { product } from "./product";
import { shape } from "./shape";
import { shadows } from "./shadows";
import { typography } from "./typography";

export default function AppTheme({
  children,
  disableCustomTheme,
  mode = defaultThemeMode,
  themeComponents,
}) {
  const theme = React.useMemo(() => {
    if (disableCustomTheme) return {};

    return createTheme({
      palette: createPalette(mode),
      typography,
      shadows,
      shape,
      product,
      components: {
        ...componentDefaults,
        ...themeComponents,
      },
    });
  }, [disableCustomTheme, mode, themeComponents]);

  if (disableCustomTheme) return children;

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
}
